
const LoadingSpinner = () => {
   return (
    <div className="fixed inset-0 z-50 flex h-screen w-screen items-center justify-center backdrop-blur-sm">
      <div className="flex flex-col items-center justify-center rounded-3xl border border-white/50 px-6 py-5 shadow-lg backdrop-blur dark:border-white/10">
        <div className="h-12 w-12 animate-spin rounded-full border-l-2 border-t-4 border-sky-900 dark:border-customWhite" />
        <div className="mt-3 text-lg font-bold text-sky-900 dark:text-customWhite">
          Loading . . .
        </div>
      </div>
    </div>
  );
  };
  
  export default LoadingSpinner;

  //  <div className={`flex h-full w-full backdrop`}>
  //       <div className="fixed flex-col inset-0 z-20 flex justify-center items-center h-screen w-screen backdrop-blur bg-customFontMilkWhite/5 dark:bg-customHeader/5 dark:bg-opacity-20 bg-opacity-50">
  //         <div className={`border-t-4 border-l-2 border-sky-900 dark:border-customWhite rounded-full animate-spin w-12 h-12`}></div>
  //         <div className={`font-bold text-sky-900 dark:text-customWhite text-lg mt-3`}>
  //           Loading . . .
  //         </div>
  //       </div>
  //     </div>